export default __webpack_public_path__ + "static/media/culture-2.a1be3417.jpg";